// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"428138b5","455":"10c25703","977":"e86a839d"}[chunkId] + ".chunk.js";
};